import React from "react";
import { translate } from "../Services/translation";

const style = {
    backgroundColor: "#2fb9a7",
    padding: "15px 40px",
    color: "white",
    textDecoration: "none",
    textAlign: "center"
}

export default function ShowAllButton(props) {
    return (
        <>
            <a style={style} href={`/${props.productPageUrl}${window.location.search}`}>
                {translate("brand.showall")}
            </a>
        </>
    )
}